import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["useRpcClient"];
import { getRulesRpc } from '../../__generated__/chirp/com/hubspot/conditional/properties/rpc/ConditionalPropertiesUnifiedRpc';
export function fetchConditionalPropertyRules(objectTypeId, httpClient, rpcClient, query) {
  if (query !== null && query !== void 0 && query.useRpcClient) {
    const rpcRequestOptions = _objectWithoutPropertiesLoose(query, _excluded);
    return rpcClient.call(getRulesRpc, {
      request: {
        objectTypeId,
        requestOptions: Object.assign({
          pageSize: 100,
          includeActualConditionalPropertyRules: true
        }, rpcRequestOptions)
      }
    }).then(response => {
      const {
        results,
        offset: newOffset,
        hasMore
      } = response;
      if (hasMore) {
        return fetchConditionalPropertyRules(objectTypeId, httpClient, rpcClient, Object.assign({}, query, {
          useRpcClient: true,
          offset: newOffset
        })).then(rules => results.concat(rules));
      }
      return results;
    });
  }
  return httpClient.get(`conditional-properties/v2/unified-rules`, {
    query: Object.assign({
      objectTypeId,
      pageSize: 100,
      includeActualConditionalPropertyRules: true
    }, query)
  }).then(response => {
    const {
      results,
      offset: newOffset,
      hasMore
    } = response;
    if (hasMore) {
      return fetchConditionalPropertyRules(objectTypeId, httpClient, rpcClient, Object.assign({}, query, {
        offset: newOffset
      })).then(rules => results.concat(rules));
    }
    return results;
  });
}